import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '../../components/ui/Button';
import { toBanglaNumber, formatCurrency } from '../../lib/utils';
import { ArrowLeft, Check } from 'lucide-react';
import { KioskScreen } from '../../components/kiosk/KioskScreen';
export function PaymentSelect() {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    quantity = 1,
    price = 20
  } = location.state || {};
  const [selectedGateway, setSelectedGateway] = useState<'bkash' | 'nagad' | null>(null);
  const total = quantity * price;
  const handlePayment = () => {
    if (selectedGateway) {
      navigate('/otp', {
        state: {
          quantity,
          total,
          gateway: selectedGateway
        }
      });
    }
  };
  return <KioskScreen data-id="element-558">
      <main className="flex-1 min-h-0 flex items-center justify-center px-6 py-4" data-id="element-559">
        <div className="w-full max-w-2xl bg-white/95 backdrop-blur-md rounded-3xl shadow-xl border border-white/80 p-6 md:p-8" data-id="element-560">
          <div className="text-center mb-5" data-id="element-561">
            <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-1" data-id="element-562">
              পেমেন্ট পদ্ধতি নির্বাচন করুন
            </h2>
            <p className="text-sm text-slate-500" data-id="element-563">
              আপনার পছন্দের গেটওয়ে বাছাই করুন
            </p>
          </div>

          {/* Summary */}
          <div className="bg-slate-50 rounded-2xl p-4 mb-5 border border-slate-100" data-id="element-564">
            <div className="grid grid-cols-3 gap-3 text-center" data-id="element-565">
              <div data-id="element-566">
                <p className="text-xs text-slate-500 mb-0.5" data-id="element-567">টিকিট</p>
                <p className="text-xl font-bold text-slate-900" data-id="element-568">
                  {toBanglaNumber(quantity)} টি
                </p>
              </div>
              <div className="border-x border-slate-200" data-id="element-569">
                <p className="text-xs text-slate-500 mb-0.5" data-id="element-570">প্রতি টিকিট</p>
                <p className="text-xl font-bold text-slate-900" data-id="element-571">
                  {formatCurrency(price)}
                </p>
              </div>
              <div data-id="element-572">
                <p className="text-xs text-slate-500 mb-0.5" data-id="element-573">সর্বমোট</p>
                <p className="text-xl font-bold text-brand-coral" data-id="element-574">
                  {formatCurrency(total)}
                </p>
              </div>
            </div>
          </div>

          {/* Gateway Cards */}
          <div className="grid grid-cols-2 gap-4 mb-6" data-id="element-575">
            <button onClick={() => setSelectedGateway('bkash')} className={`relative flex flex-col items-center justify-center p-5 rounded-2xl border-2 transition-all ${selectedGateway === 'bkash' ? 'border-[#e2136e] bg-[#e2136e]/5 shadow-md' : 'border-slate-200 bg-white hover:border-slate-300'}`} data-id="element-576">
              {selectedGateway === 'bkash' && <div className="absolute top-2 right-2 w-6 h-6 bg-[#e2136e] rounded-full flex items-center justify-center" data-id="element-577">
                  <Check className="w-4 h-4 text-white" data-id="element-578" />
                </div>}
              <div className="w-14 h-14 bg-[#e2136e] rounded-2xl flex items-center justify-center mb-2 shadow" data-id="element-579">
                <span className="text-white font-bold text-base" data-id="element-580">bKash</span>
              </div>
              <span className="font-bold text-slate-900" data-id="element-581">বিকাশ</span>
            </button>

            <button onClick={() => setSelectedGateway('nagad')} className={`relative flex flex-col items-center justify-center p-5 rounded-2xl border-2 transition-all ${selectedGateway === 'nagad' ? 'border-[#f7931e] bg-[#f7931e]/5 shadow-md' : 'border-slate-200 bg-white hover:border-slate-300'}`} data-id="element-582">
              {selectedGateway === 'nagad' && <div className="absolute top-2 right-2 w-6 h-6 bg-[#f7931e] rounded-full flex items-center justify-center" data-id="element-583">
                  <Check className="w-4 h-4 text-white" data-id="element-584" />
                </div>}
              <div className="w-14 h-14 bg-[#f7931e] rounded-2xl flex items-center justify-center mb-2 shadow" data-id="element-585">
                <span className="text-white font-bold text-base" data-id="element-586">Nagad</span>
              </div>
              <span className="font-bold text-slate-900" data-id="element-587">নগদ</span>
            </button>
          </div>

          {/* Actions */}
          <div className="grid grid-cols-2 gap-3" data-id="element-588">
            <Button variant="outline" size="lg" className="w-full" onClick={() => navigate(-1)} data-id="element-589">
              <ArrowLeft className="w-5 h-5 mr-2" data-id="element-590" />
              পেছনে যান
            </Button>
            <Button size="lg" className="w-full" disabled={!selectedGateway} onClick={handlePayment} data-id="element-591">
              পেমেন্ট করুন
            </Button>
          </div>
        </div>
      </main>
    </KioskScreen>;
}